import { PhotoDesign } from '../enums/photoDesign';

export const PHOTO_BOOTH_DESCRIPTION =
  'Bring color to your classroom with Photo Booth. Transform teaching ideas into stunning visuals with AI-generated images.';

export const PHOTO_DESIGN_OPTIONS = [
  {
    value: PhotoDesign.REALISTIC,
    label: 'Realistic',
  },
  {
    value: PhotoDesign.ANIMATED,
    label: 'Animated',
  },
];

export const PROMPT_PER_DESIGN: Record<PhotoDesign, string> = {
  [PhotoDesign.REALISTIC]: 'photoBoothRealistic',
  [PhotoDesign.ANIMATED]: 'photoBoothCartoon',
  [PhotoDesign.GEOMETRIC]: 'photoBoothGeometric',
};

export const GENERATE_AI_IMAGE_PROMPT = 'aiImagePrompt';
